export default __webpack_public_path__ + "static/media/242.a1cbabf7.png";